import React, { useMemo } from 'react';
import CoursesSlider from '../CoursesSlider/CoursesSlider';
import {
    IAchievementItemApiModel,
    ICourseInformationApiModel,
    IUserCoursesItemApiModel,
} from '@app/models/features/course';
import CoursesBlockItem from './CoursesBlockItem';
import { getAchievementsById } from '@app/features/academy/academy.helper';

export interface IProps {
    /**
     * Список курсов
     */
    courses: Array<ICourseInformationApiModel>;
    /**
     * Список курсов пользователя
     */
    states: Array<IUserCoursesItemApiModel>;
    /**
     * Список ачивок
     */
    achievements: IAchievementItemApiModel[];
}

/**
 * Блок со всеми курсами
 */
const CoursesBlock:React.FC<IProps> = props => {
    const {
        courses,
        achievements,
        states,
    } = props;

    const coursesState = useMemo(() => courses?.reduce((acc, courseState) => {
        acc[courseState.id] = courseState;
        return acc;
    }, {}), [courses]);

    const achievementsMap = useMemo(() => getAchievementsById(achievements), [achievements]);

    return (
        <CoursesSlider>
            {states?.map(course => (
                <CoursesBlockItem
                    key={course?.id}
                    achievementsMap={achievementsMap}
                    course={coursesState?.[course?.id]}
                    state={course}
                />
            ))}
        </CoursesSlider>
    );
};

export default CoursesBlock;